module.exports = __webpack_public_path__ + "media/images/logo-adcurve-dark-bg-4e380d137fea431f5c6014484feffb2e.svg";